import React, { Component } from 'react';
import { connect } from 'react-redux';
/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class AttachmentsCounter extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("span", { className: 'badge-round' },
            React.createElement("span", null, !this.props._isOpen
                && (this.props._count || null))));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounter}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    const { isOpen } = state['features/chat'];
    const { _nbAttachments } = state['features/attachments'];
    return {
        _count: _nbAttachments,
        _isOpen: isOpen
    };
}
export default connect(_mapStateToProps)(AttachmentsCounter);
